$(document).ready(function () {
  $('.studio_drop_down').click(function () {
    $(this).parents('li').addClass('studio_active_drop_down');
  });

  $('.back_main_menu').click(function () {
    $(this).parents('li').removeClass('studio_active_drop_down');
  });

  function variant_qty() {
    $('.sizevariant_option-1 label input').each(function () {
      var all_size = $(this).val();
      var qty_data = parseInt(
        $('.product_variants option[data-opt1="' + all_size + '"]').attr('data-qty'),
        10,
      );

      if (qty_data <= 0) {
        $(this).attr('data-disabled', 'true');
        $(this).attr('data-disabled-aria', 'true');
        $(this).attr('aria-disabled', 'true');

        // Add "COMING SOON" badge if not already added
        var variantLabel = $(this).parent();
        if (!variantLabel.find('.coming-soon-badge').length) {
          variantLabel.append('<span class="coming-soon-badge">COMING SOON</span>');
        }
      } else {
        $(this).removeAttr('data-disabled');

        // Remove "COMING SOON" badge if stock is available
        $(this).parent().find('.coming-soon-badge').remove();
      }
    });
  }

  $('.product_variant_option .product-section__options-values-wrapper label').click(function () {
    setTimeout(variant_qty, 10);
  });

  // Initial call to variant_qty to set up initial states
  variant_qty();
  setTimeout(variant_qty, 500);
});
(() => {
  if (!window.location.pathname.includes('/privacy-policy')) return;

  const scrollToHash = (hash) => {
    if (!hash || hash === '#') return;

    const target = document.querySelector(hash);
    if (!target) return;

    const heading = target.querySelector('h2') || target;

    const headerHeight =
      document.querySelector('.header, .site-header, .sticky-header')?.offsetHeight || 0;

    window.scrollTo({
      top: heading.getBoundingClientRect().top + window.scrollY - headerHeight - 5,
      behavior: 'smooth',
    });
  };

  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href*="#"]');
    if (!anchor) return;

    const { pathname, hash } = new URL(anchor.href);

    if (pathname !== window.location.pathname || !hash) return;

    e.preventDefault();

    history.pushState(null, '', hash);

    scrollToHash(hash);
  });

  window.addEventListener('load', () => {
    if (window.location.hash) {
      setTimeout(() => scrollToHash(window.location.hash), 100);
    }
  });
})();

(() => {
  if (!window.location.pathname.includes('/products/')) return;

  const desktopBreakpoint = window.matchMedia('(min-width: 1025px)');

  const syncPdpThumbnailHeight = () => {
    const mainMedia = document.querySelector('.product-media-main');
    const thumbnailRail = document.querySelector('.product-media-thumbnail');

    if (!mainMedia || !thumbnailRail) return;

    if (!desktopBreakpoint.matches) {
      thumbnailRail.style.removeProperty('height');
      window.schedulePdpSwiperUpdate?.();
      return;
    }

    const mainMediaHeight = Math.round(mainMedia.getBoundingClientRect().height);
    if (mainMediaHeight <= 0) return;

    document.body.style.setProperty('--feature-image-height', `${mainMediaHeight}px`);
    thumbnailRail.style.height = `${mainMediaHeight}px`;
    window.schedulePdpSwiperUpdate?.();
  };

  const queueSync = () => window.requestAnimationFrame(syncPdpThumbnailHeight);

  document.addEventListener('DOMContentLoaded', queueSync);
  window.addEventListener('load', queueSync);
  window.addEventListener('resize', queueSync);
  window.addEventListener('orientationchange', queueSync);
  desktopBreakpoint.addEventListener('change', queueSync);

  document.addEventListener('click', (event) => {
    if (
      event.target.closest(
        '.product-thumbnail-item, .product-swiper-button-next, .product-swiper-button-prev, .swiper-thumb-next, .swiper-thumb-prev',
      )
    ) {
      setTimeout(queueSync, 80);
    }
  });

  const firstGalleryImage = document.querySelector('.product-media-main img.pdp-zoom-image');
  if (firstGalleryImage && !firstGalleryImage.complete) {
    firstGalleryImage.addEventListener('load', queueSync, { once: true });
  }
})();

(() => {
  if (!window.location.pathname.includes('/products/')) return;

  const zoomMediaQuery = window.matchMedia(
    '(hover: hover) and (pointer: fine) and (min-width: 1025px)',
  );
  const slideSelector = '.product-media-main .product-featured-image.swiper-slide';
  const zoomImageSelector = '.pdp-zoom-image';
  const boundSlides = new Map();

  const clampPercent = (value) => Math.max(0, Math.min(100, value));

  const setZoomOrigin = (slide, event) => {
    const image = slide.querySelector(zoomImageSelector);
    if (!image) return;

    const rect = slide.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = clampPercent(((event.clientX - rect.left) / rect.width) * 100);
    const y = clampPercent(((event.clientY - rect.top) / rect.height) * 100);

    image.style.transformOrigin = `${x}% ${y}%`;
  };

  const bindSlide = (slide) => {
    if (boundSlides.has(slide)) return;

    const image = slide.querySelector(zoomImageSelector);
    if (!image) return;

    let rafId = null;
    let latestEvent = null;

    const onEnter = (event) => {
      latestEvent = event;
      setZoomOrigin(slide, event);
      image.classList.add('is-zooming');
    };

    const onMove = (event) => {
      latestEvent = event;
      if (rafId) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = null;
        if (latestEvent) setZoomOrigin(slide, latestEvent);
      });
    };

    const onLeave = () => {
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
      image.classList.remove('is-zooming');
      image.style.transformOrigin = '50% 50%';
    };

    slide.addEventListener('mouseenter', onEnter);
    slide.addEventListener('mousemove', onMove);
    slide.addEventListener('mouseleave', onLeave);

    boundSlides.set(slide, { onEnter, onMove, onLeave });
  };

  const unbindAllSlides = () => {
    boundSlides.forEach((handlers, slide) => {
      slide.removeEventListener('mouseenter', handlers.onEnter);
      slide.removeEventListener('mousemove', handlers.onMove);
      slide.removeEventListener('mouseleave', handlers.onLeave);

      const image = slide.querySelector(zoomImageSelector);
      if (image) {
        image.classList.remove('is-zooming');
        image.style.transformOrigin = '50% 50%';
      }
    });

    boundSlides.clear();
  };

  const initZoom = () => {
    if (!zoomMediaQuery.matches) {
      unbindAllSlides();
      return;
    }

    document.querySelectorAll(slideSelector).forEach(bindSlide);
  };

  document.addEventListener('DOMContentLoaded', initZoom);
  window.addEventListener('load', initZoom);
  window.addEventListener('resize', initZoom);
  zoomMediaQuery.addEventListener('change', initZoom);

  // Ensure listeners exist for slides that Swiper may re-render/duplicate.
  document.addEventListener('click', (event) => {
    if (
      event.target.closest(
        '.product-thumbnail-item, .swiper-thumb-next, .swiper-thumb-prev, .product-swiper-button-next, .product-swiper-button-prev',
      )
    ) {
      setTimeout(initZoom, 60);
    }
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  // Append Read More button
  document.querySelectorAll('.em-read-default').forEach(function (element) {
    if (!element || typeof element.insertAdjacentHTML !== 'function') return;
    element.insertAdjacentHTML(
      'beforeend',
      ' <a href="javascript:void(0);" class="cus-read0 read-more-btn">read more</a>',
    );
  });

  // Append Read Less button
  document.querySelectorAll('.em-read-more').forEach(function (element) {
    if (!element || typeof element.insertAdjacentHTML !== 'function') return;
    element.insertAdjacentHTML(
      'beforeend',
      ' <a href="javascript:void(0);" class="cus-read0 read-less-btn">read less</a>',
    );
  });

  // Read More click
  document.querySelectorAll('.read-more-btn').forEach(function (button) {
    button.addEventListener('click', function () {
      this.style.display = 'none';

      document.querySelectorAll('.em-read-more').forEach(function (element) {
        element.classList.add('active');
      });
    });
  });

  // Read Less click
  document.querySelectorAll('.read-less-btn').forEach(function (button) {
    button.addEventListener('click', function () {
      this.parentElement.classList.remove('active');

      document.querySelectorAll('.read-more-btn').forEach(function (btn) {
        btn.style.display = '';
      });
    });
  });
});
/**
 * Re-sync cart UI after bfcache restore (e.g. Back from /cart after Quick View add).
 * Does not change add-to-cart behavior — only refreshes state/sections when returning via history.
 */
/**
 * Re-sync cart after Back from /cart (Quick View full redirect).
 * Uses GET /cart.js first so badge + body class update reliably.
 */
(function () {
  function getAjaxCartSectionIds() {
    return [
      ...new Set(
        [...document.querySelectorAll('[data-ajax-cart-section]')]
          .map((el) => el.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', ''))
          .filter(Boolean),
      ),
    ];
  }

  function isCartPage() {
    return /(?:^|\/)cart\/?$/.test(window.location.pathname);
  }

  function refreshCartFromServer() {
    if (!window.liquidAjaxCart?.cartRequestGet) return;

    window.liquidAjaxCart.cartRequestGet({
      lastComplete: function () {
        if (isCartPage()) return;
        const sections = getAjaxCartSectionIds();
        if (sections.length && window.liquidAjaxCart.cartRequestUpdate) {
          window.liquidAjaxCart.cartRequestUpdate({ sections: sections.join(',') }, {});
        }
      },
    });
  }

  function shouldSyncCartOnPageShow(event) {
    if (event.persisted) return true;
    const nav = performance.getEntriesByType?.('navigation')?.[0];
    return nav?.type === 'back_forward';
  }

  window.addEventListener('pageshow', function (event) {
    if (shouldSyncCartOnPageShow(event)) {
      refreshCartFromServer();
    }
  });
})();

(() => {
  if (!window.location.pathname.includes('/products/')) return;

  const pendingButtons = new Set();
  let ajaxCartSubscribed = false;

  const isProductAddForm = (form) => {
    if (!form) return false;
    const action = form.getAttribute('action') || '';
    return action.includes('/cart/add') || form.hasAttribute('data-product-form');
  };

  const resetButton = (button) => {
    if (!button) return;
    if (button.dataset.originalText) {
      button.textContent = button.dataset.originalText;
      delete button.dataset.originalText;
    }
    button.disabled = false;
    button.removeAttribute('aria-busy');
    pendingButtons.delete(button);
  };

  const resetPendingButtons = () => {
    pendingButtons.forEach(resetButton);
  };

  const setButtonLoading = (button) => {
    if (!button || button.disabled || pendingButtons.has(button)) return;
    button.dataset.originalText = button.textContent.trim();
    button.textContent = 'Adding...';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    pendingButtons.add(button);

    window.setTimeout(() => {
      if (pendingButtons.has(button)) resetButton(button);
    }, 10000);
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!isProductAddForm(form)) return;

      setButtonLoading(form.querySelector('[type="submit"][name="add"], [type="submit"]'));
    },
    true,
  );

  const subscribeToAjaxCart = () => {
    if (ajaxCartSubscribed || !window.liquidAjaxCart?.subscribeToCartAjaxRequests) return;
    ajaxCartSubscribed = true;

    window.liquidAjaxCart.subscribeToCartAjaxRequests((requestState, subscribeToResult) => {
      if (requestState.requestType !== 'add') return;
      subscribeToResult(resetPendingButtons);
    });
  };

  subscribeToAjaxCart();
  document.addEventListener('DOMContentLoaded', subscribeToAjaxCart);
  window.setTimeout(subscribeToAjaxCart, 500);
})();
(() => {
  const PRODUCT_LIMIT_MESSAGE =
    window.BBThemeSettings?.cartQuantityLimitMessage ||
    'You can only add a maximum of 3 units of this product to your cart.';
  const quantityErrorPattern =
    /maximum|max quantity|can't add more|can only add|only add|only \d+ items? (?:was|were) added|due to availability/i;

  const escapeHtml = (value) =>
    String(value).replace(
      /[&<>"']/g,
      (char) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        })[char],
    );

  const setupAjaxCartMessageText = () => {
    if (!window.liquidAjaxCart?.configureCart || setupAjaxCartMessageText.done) return;
    setupAjaxCartMessageText.done = true;

    window.liquidAjaxCart.configureCart('messageBuilder', (messages) => {
      return messages
        .map((message) => {
          const text = quantityErrorPattern.test(String(message.text || ''))
            ? PRODUCT_LIMIT_MESSAGE
            : message.text;

          return `<div class="js-ajax-cart-message js-ajax-cart-message--${message.type}">${escapeHtml(text)}</div>`;
        })
        .join('');
    });
  };

  setupAjaxCartMessageText();
  document.addEventListener('liquidAjaxCartInit', setupAjaxCartMessageText);
})();
(() => {
  const CART_ATTR_KEY = '_web';
  const CART_ATTR_VALUE = 'true';
  let isApplying = false;

  const hasWeb2Attribute = (cart) => cart?.attributes?.[CART_ATTR_KEY] === CART_ATTR_VALUE;

  const ensureWeb2Attribute = () => {
    if (isApplying || !window.liquidAjaxCart?.cartRequestUpdate) return;

    const state = window.liquidAjaxCart.getCartState?.();
    if (!state?.status?.cartStateSet) return;
    if (hasWeb2Attribute(state.cart)) return;

    isApplying = true;
    window.liquidAjaxCart.cartRequestUpdate(
      { attributes: { [CART_ATTR_KEY]: CART_ATTR_VALUE } },
      {
        lastComplete: () => {
          isApplying = false;
        },
      },
    );
  };

  const init = () => {
    ensureWeb2Attribute();

    if (window.liquidAjaxCart?.subscribeToCartStateUpdate && !init.subscribed) {
      init.subscribed = true;
      window.liquidAjaxCart.subscribeToCartStateUpdate((state) => {
        if (!state.status?.cartStateSet || isApplying) return;
        if (!hasWeb2Attribute(state.cart)) ensureWeb2Attribute();
      });
    }
  };

  document.addEventListener('liquidAjaxCartInit', init);
  document.addEventListener('DOMContentLoaded', init);
})();

(() => {
  const MOBILE_MAX = window.THEME_GLOBAL?.BREAKPOINT?.TABLET ?? 767;

  const blockImageAreaNavigation = (imageBox) => {
    if (!imageBox || imageBox.dataset.navBlocked === 'true') return;
    imageBox.dataset.navBlocked = 'true';

    const stopNavigation = (event) => {
      if (window.innerWidth > MOBILE_MAX) return;
      if (event.target.closest('.product-card__copy-link')) return;

      const link = event.target.closest('a[href]');
      if (link && imageBox.contains(link)) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    imageBox.addEventListener('click', stopNavigation, true);
  };

  if (!document.documentElement.dataset.productCardMediaTouchBound) {
    document.documentElement.dataset.productCardMediaTouchBound = 'true';

    document.addEventListener(
      'touchstart',
      (event) => {
        if (window.innerWidth > MOBILE_MAX) return;

        document.querySelectorAll('.product-card.is-media-active').forEach((card) => {
          if (!card.contains(event.target)) {
            card.classList.remove('is-media-active');
          }
        });
      },
      { passive: true },
    );
  }

  const isCenterProductSlide = (track) =>
    Boolean(track?.closest('.product-card__item.swiper-slide-active'));

  const getSlideCount = (track) => {
    const fromData = Number(track?.dataset.slideCount);
    if (!Number.isNaN(fromData) && fromData > 0) return fromData;
    return track?.children.length ?? 0;
  };

  const mapSlideIndexToDotIndex = (slideIndex, slideCount, dotCount) => {
    if (dotCount <= 1 || slideCount <= 1) return 0;
    if (slideCount <= dotCount) return Math.min(slideIndex, dotCount - 1);
    return Math.round((slideIndex / (slideCount - 1)) * (dotCount - 1));
  };

  const mapDotIndexToSlideIndex = (dotIndex, slideCount, dotCount) => {
    if (dotCount <= 1 || slideCount <= 1) return 0;
    if (slideCount <= dotCount) return Math.min(dotIndex, slideCount - 1);
    return Math.round((dotIndex / (dotCount - 1)) * (slideCount - 1));
  };

  const bindMainSwiperSlideSync = () => {
    document.querySelectorAll('products-list .products-list__content.swiper').forEach((el) => {
      if (!el.swiper || el.dataset.cardTrackSyncBound === 'true') return;
      el.dataset.cardTrackSyncBound = 'true';

      const syncInnerTracks = () => {
        el.querySelectorAll('[data-product-card-track]').forEach((track) => {
          const slide = track.closest('.product-card__item');
          const productCard = track.closest('.product-card');

          if (!slide?.classList.contains('swiper-slide-active')) {
            track.scrollLeft = 0;

            const card = track.closest('.product-card__media-swiper');
            const dots = card ? Array.from(card.querySelectorAll('.product-card__media-dot')) : [];
            dots.forEach((dot, index) => {
              const isActive = index === 0;
              dot.classList.toggle('swiper-pagination-bullet-active', isActive);
              dot.setAttribute('aria-current', isActive ? 'true' : 'false');
            });
          }

          productCard?.classList.remove('is-media-active');
        });
      };

      el.swiper.on('slideChange', syncInnerTracks);
      el.swiper.on('transitionEnd', syncInnerTracks);
      syncInnerTracks();
    });
  };

  const initProductCardTracks = (root = document) => {
    root.querySelectorAll('[data-product-card-track]').forEach((track) => {
      if (track.dataset.trackBound === 'true') return;
      track.dataset.trackBound = 'true';

      const imageBox = track.closest('.product-card__image-box');
      const productCard = track.closest('.product-card');
      const mediaMobile = track.closest('.product-card__media-mobile');
      blockImageAreaNavigation(imageBox);

      const setMediaActive = () => {
        if (!isCenterProductSlide(track)) return;
        productCard?.classList.add('is-media-active');
      };

      const clearMediaActive = () => {
        productCard?.classList.remove('is-media-active');
      };

      mediaMobile?.addEventListener('touchstart', setMediaActive, { passive: true });
      mediaMobile?.addEventListener('focusin', setMediaActive);

      mediaMobile?.addEventListener('focusout', (event) => {
        if (!mediaMobile.contains(event.relatedTarget)) {
          clearMediaActive();
        }
      });

      const copyLink = productCard?.querySelector('.product-card__copy-link');
      copyLink?.addEventListener('focusin', clearMediaActive);
      copyLink?.addEventListener('touchstart', clearMediaActive, { passive: true });

      const card = track.closest('.product-card__media-swiper');
      const dots = card ? Array.from(card.querySelectorAll('.product-card__media-dot')) : [];
      const slideCount = getSlideCount(track);
      const dotCount = dots.length;
      let startX = 0;
      let startScrollLeft = 0;

      const setActiveDot = (slideIndex) => {
        const activeDotIndex = mapSlideIndexToDotIndex(slideIndex, slideCount, dotCount);
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeDotIndex;
          dot.classList.toggle('swiper-pagination-bullet-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const getActiveIndex = () => {
        if (!track.clientWidth) return 0;
        return Math.round(track.scrollLeft / track.clientWidth);
      };

      track.addEventListener(
        'scroll',
        () => {
          window.requestAnimationFrame(() => setActiveDot(getActiveIndex()));
        },
        { passive: true },
      );

      dots.forEach((dot) => {
        dot.addEventListener('click', (event) => {
          if (!isCenterProductSlide(track)) return;

          event.preventDefault();
          event.stopPropagation();

          const dotIndex = Number(dot.dataset.dotIndex);
          if (Number.isNaN(dotIndex)) return;

          const slideIndex = mapDotIndexToSlideIndex(dotIndex, slideCount, dotCount);

          track.scrollTo({
            left: slideIndex * track.clientWidth,
            behavior: 'smooth',
          });
          setActiveDot(slideIndex);
        });
      });

      track.addEventListener(
        'click',
        (event) => {
          if (window.innerWidth > MOBILE_MAX) return;
          if (!isCenterProductSlide(track)) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true,
      );

      track.addEventListener(
        'touchstart',
        (event) => {
          if (!isCenterProductSlide(track)) return;
          startX = event.touches[0].clientX;
          startScrollLeft = track.scrollLeft;
        },
        { passive: true },
      );

      track.addEventListener(
        'touchmove',
        (event) => {
          if (!isCenterProductSlide(track)) return;

          const maxScroll = track.scrollWidth - track.clientWidth;
          if (maxScroll <= 0) return;

          const deltaX = event.touches[0].clientX - startX;
          const atStart = startScrollLeft <= 0 && deltaX > 0;
          const atEnd = startScrollLeft >= maxScroll - 1 && deltaX < 0;

          if (!atStart && !atEnd) {
            event.stopPropagation();
          }
        },
        { passive: true },
      );
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initProductCardTracks();
    bindMainSwiperSlideSync();
    setTimeout(() => {
      initProductCardTracks();
      bindMainSwiperSlideSync();
    }, 500);
  });

  document.querySelectorAll('products-list').forEach((list) => {
    new MutationObserver(() => {
      initProductCardTracks(list);
      bindMainSwiperSlideSync();
    }).observe(list, {
      childList: true,
      subtree: true,
    });
  });
})();
